import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/rank-in-ai-search-colorado")!;

export const Route = createFileRoute("/learn/rank-in-ai-search-colorado")({
  head: () => seoHead("/learn/rank-in-ai-search-colorado", "How Colorado Businesses Get Recommended by ChatGPT & AI", "How to show up when customers ask AI tools for local recommendations: clear service pages, honest pricing, consistent details, and reviews.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
